"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const react_dom_1 = require("react-dom");
const Portal = ({ children, id }) => {
    const ref = (0, react_1.useRef)(null);
    const [mounted, setMounted] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        if (!ref.current) {
            if (document.querySelector(`#${id}`)) {
                ref.current = document.querySelector(`#${id}`);
            }
            else {
                const container = document.createElement('div');
                container.id = id;
                document.body.prepend(container);
                ref.current = container;
            }
        }
        setMounted(true);
    }, [id]);
    if (!ref.current || !mounted)
        return null;
    return (0, react_dom_1.createPortal)(children, ref.current);
};
exports.default = Portal;
